//src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, browserSessionPersistence, inMemoryPersistence, setPersistence } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAtypXBeRTO2n2rLH78dv77LUp_btoRuDI",
  // Use the Firebase-managed auth domain so the hidden /__/auth/iframe loads
  // from a different origin and can't accidentally boot the SPA (which would
  // fire phantom analytics via the catch-all route). Email/password auth and
  // email link flows are unaffected — actionCodeSettings.url controls those.
  authDomain: "learning-app-6f8ff.firebaseapp.com",
  projectId: "learning-app-6f8ff",
  storageBucket: "learning-app-6f8ff.firebasestorage.app",
  messagingSenderId: "497981961771",
  appId: "1:497981961771:web:818f38e41aef2fd9f39c6e",
  measurementId: "G-VNDHLQHZY8"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Safari private mode (and some mobile browsers) throw on localStorage AND
// IndexedDB writes. Try persistence methods from most-durable to least:
//   1. localStorage (survives tab close)
//   2. sessionStorage (survives refresh, lost on tab close)
//   3. in-memory (lost on any navigation — last resort)
setPersistence(auth, browserLocalPersistence)
  .catch(() => setPersistence(auth, browserSessionPersistence))
  .catch(() => setPersistence(auth, inMemoryPersistence))
  .catch((err) => {
    console.warn('All auth persistence methods failed:', err);
  });

// Detect if IndexedDB is available (Safari private mode blocks it).
// Fall back to in-memory cache so Firestore doesn't crash silently.
let firestoreSettings;
try {
  // Quick probe: open + delete a throwaway DB to see if IndexedDB works
  const probe = indexedDB.open('__idb_probe');
  probe.onerror = () => {};
  firestoreSettings = { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) };
} catch {
  firestoreSettings = { localCache: memoryLocalCache() };
}
export const db = initializeFirestore(app, firestoreSettings);

export default app;